export default __webpack_public_path__ + "static/media/happy-face.22675009.svg";